import { Controller } from 'react-hook-form';
import { FormTextField } from './FormTextField';

export const FormNumberField = ({ onChange, onKeyDown, ...rest }) => {
  const handleChange = (e) => {
    const val = e.target.value;
    if (val === '' || Number(val) >= 0) {
      onChange(e);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === '-') e.preventDefault();
    if (onKeyDown) onKeyDown(e);
  };

  return (
    <FormTextField {...rest} type="number" onChange={handleChange} onKeyDown={handleKeyDown} />
  );
};

export const FormControlledNumberField = ({ name, control, rules, required, ...props }) => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field, fieldState: { error } }) => (
      <FormNumberField
        id={name}
        {...field}
        required={rules?.required || required}
        error={!!error}
        helperText={error?.message}
        {...props}
      />
    )}
  />
);
